// Generated by Avo VERSION 235.16.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Staging = "staging",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "X8YF9EsphQw5x212kjUq";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "NrliJGrxNjiWh800Xtjy",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "JnsCIDGMj",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "NrliJGrxNjiWh800Xtjy",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "JnsCIDGMj",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "JmwsgKTQe50MTmUE9FVs",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface Preferences {
  occasion: string
  color: string
  note: boolean
}

export const ErrorType = {
  'BOOKING_FAILED': 'booking_failed',
  'CAPTCHA_FAILED': 'captcha_failed',
  'EMPLOYEES_FAILED': 'employees_failed',
  'STORES_FAILED': 'stores_failed',
  'TIMESLOTS_FAILED': 'timeslots_failed',
} as const;
export type ErrorTypeType = typeof ErrorType;
export type ErrorTypeValueType = ErrorTypeType[keyof ErrorTypeType];

export const LoggedIn = {
  'FALSE': 'false',
  'TRUE': 'true',
} as const;
export type LoggedInType = typeof LoggedIn;
export type LoggedInValueType = LoggedInType[keyof LoggedInType];

export const EventCategory = {
  'CHECKOUT_INTERACTIONS': 'checkout_interactions',
  'PLP_INTERACTIONS': 'plp_interactions',
  'PDP_INTERACTIONS': 'pdp_interactions',
  'GLOBAL_INTERACTIONS': 'global_interactions',
  'FOOTER_INTERACTIONS': 'footer_interactions',
  'JOURNAL_INTERACTIONS': 'journal_interactions',
  'CM_INTERACTIONS': 'cm_interactions',
  'LOOKBUILDER_INTERACTIONS': 'lookbuilder_interactions',
  'INSTORE_INTERACTIONS': 'instore_interactions',
  'ECOMMERCE_INTERACTIONS': 'ecommerce_interactions',
  'BTC_INTERACTIONS': 'btc_interactions',
  'BOOKING_INTERACTIONS': 'booking_interactions',
  'LOGIN_INTERACTIONS': 'login_interactions',
  'SP_INTERACTIONS': 'sp_interactions',
  'CONFIGURATOR_INTERACTIONS': 'configurator_interactions',
  'RETURNING_ITEM_INTERACTIONS': 'returning_item_interactions',
} as const;
export type EventCategoryType = typeof EventCategory;
export type EventCategoryValueType = EventCategoryType[keyof EventCategoryType];

export const Language = {
  'DE': 'de',
  'EN': 'en',
  'ES': 'es',
  'FR': 'fr',
  'IT': 'it',
  'KO': 'ko',
  'NL': 'nl',
  'PL': 'pl',
  'SV': 'sv',
  'ZH': 'zh',
} as const;
export type LanguageType = typeof Language;
export type LanguageValueType = LanguageType[keyof LanguageType];

export const PageType = {
  'ACCOUNT': 'account',
  'BLACK_TIE_CONFIGURATOR': 'black-tie-configurator',
  'BLACK_TIE_CONFIGURATOR': 'black_tie_configurator',
  'BOOKING_TOOL': 'booking_tool',
  'CART': 'cart',
  'CATEGORY': 'category',
  'CATEGORY_LANDING': 'category_landing',
  'CHECKOUT': 'checkout',
  'CUSTOMMADE': 'custommade',
  'EMPLOYEE_PROFILE': 'employee_profile',
  'ERROR': 'error',
  'GIFTCARD': 'giftcard',
  'HOME': 'home',
  'INSTORE': 'instore',
  'JOURNAL': 'journal',
  'LOGIN': 'login',
  'LOOKBUILDER': 'lookbuilder',
  'MINI_CART': 'mini-cart',
  'ORDER_CONFIRMATION': 'order_confirmation',
  'PRODUCT': 'product',
  'PRODUCT_DETAIL_PAGE': 'product_detail_page',
  'PRODUCT_LIST_PAGE': 'product_list_page',
  'RETURN': 'return',
  'RETURN_CONFIRMATION': 'return_confirmation',
  'STORE': 'store',
  'STORE_DETAILS': 'store_details',
  'STORE_LOCATOR': 'store_locator',
  'STORE_OVERVIEW': 'store_overview',
  'SUPPORT': 'support',
  'WISHLIST': 'wishlist',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const FlowType = {
  'CANCEL': 'cancel',
  'NEW': 'new',
  'RESCHEDULE': 'reschedule',
} as const;
export type FlowTypeType = typeof FlowType;
export type FlowTypeValueType = FlowTypeType[keyof FlowTypeType];

export const SelectedCountry = {
  'AE': 'ae',
  'AT': 'at',
  'AU': 'au',
  'BE': 'be',
  'BG': 'bg',
  'BN': 'bn',
  'CA': 'ca',
  'CH': 'ch',
  'CN': 'cn',
  'CY': 'cy',
  'CZ': 'cz',
  'DE': 'de',
  'DK': 'dk',
  'DO': 'do',
  'EE': 'ee',
  'ES': 'es',
  'FI': 'fi',
  'FR': 'fr',
  'GB': 'gb',
  'GH': 'gh',
  'GI': 'gi',
  'GP': 'gp',
  'GR': 'gr',
  'GW': 'gw',
  'HK': 'hk',
  'HR': 'hr',
  'HU': 'hu',
  'IE': 'ie',
  'IN': 'in',
  'IR': 'ir',
  'IS': 'is',
  'IT': 'it',
  'JE': 'je',
  'JP': 'jp',
  'KR': 'kr',
  'LI': 'li',
  'LT': 'lt',
  'LU': 'lu',
  'LV': 'lv',
  'LY': 'ly',
  'MC': 'mc',
  'MO': 'mo',
  'MQ': 'mq',
  'MT': 'mt',
  'MV': 'mv',
  'MY': 'my',
  'NL': 'nl',
  'NO': 'no',
  'PL': 'pl',
  'PR': 'pr',
  'PT': 'pt',
  'QA': 'qa',
  'RO': 'ro',
  'SE': 'se',
  'SG': 'sg',
  'SI': 'si',
  'SK': 'sk',
  'TT': 'tt',
  'US': 'us',
} as const;
export type SelectedCountryType = typeof SelectedCountry;
export type SelectedCountryValueType = SelectedCountryType[keyof SelectedCountryType];

export const Country = {
  'AE': 'ae',
  'AT': 'at',
  'AU': 'au',
  'BE': 'be',
  'BG': 'bg',
  'BN': 'bn',
  'CA': 'ca',
  'CH': 'ch',
  'CN': 'cn',
  'CY': 'cy',
  'CZ': 'cz',
  'DE': 'de',
  'DK': 'dk',
  'DO': 'do',
  'EE': 'ee',
  'ES': 'es',
  'FI': 'fi',
  'FR': 'fr',
  'GB': 'gb',
  'GH': 'gh',
  'GI': 'gi',
  'GP': 'gp',
  'GR': 'gr',
  'GW': 'gw',
  'HK': 'hk',
  'HR': 'hr',
  'HU': 'hu',
  'IE': 'ie',
  'IN': 'in',
  'IR': 'ir',
  'IS': 'is',
  'IT': 'it',
  'JE': 'je',
  'JP': 'jp',
  'KR': 'kr',
  'LI': 'li',
  'LT': 'lt',
  'LU': 'lu',
  'LV': 'lv',
  'LY': 'ly',
  'MC': 'mc',
  'MO': 'mo',
  'MQ': 'mq',
  'MT': 'mt',
  'MV': 'mv',
  'MY': 'my',
  'NL': 'nl',
  'NO': 'no',
  'PL': 'pl',
  'PR': 'pr',
  'PT': 'pt',
  'QA': 'qa',
  'RO': 'ro',
  'SE': 'se',
  'SG': 'sg',
  'SI': 'si',
  'SK': 'sk',
  'TT': 'tt',
  'US': 'us',
} as const;
export type CountryType = typeof Country;
export type CountryValueType = CountryType[keyof CountryType];

export const ApplicationId = {
  'BOOKING_TOOL': 'booking_tool',
} as const;
export type ApplicationIdType = typeof ApplicationId;
export type ApplicationIdValueType = ApplicationIdType[keyof ApplicationIdType];

let sysApplicationId: any;
let sysVersion: any;
let sysAffiliateMarker: any;
let sysAwc: any;
let sysCountry: any;
let sysLanguage: any;
let sysLocationId: any;
let sysUserId: any;
let sysLoggedIn: any;
let sysPageType: any;
let sysGaClientId: any;
let sysGaSessionId: any;
let sysGaSessionNumber: any;
let sysFbFbp: any;
let sysFbFbc: any;
let sysGaAwClid: any;
let sysTtclid: any;
let sysMsclkid: any;
let sysTwclid: any;
let sysRdtCid: any;
let sysEpik: any;

export function setSystemProperties(properties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string;
    awc: string;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string;
    fbFbc: string;
    gaAwClid: string;
    ttclid: string;
    msclkid: string;
    twclid: string;
    rdtCid: string;
    epik: string}) {
  if (properties.applicationId !== null && properties.applicationId !== undefined) {
    sysApplicationId = properties.applicationId;
  }
  if (properties.version !== null && properties.version !== undefined) {
    sysVersion = properties.version;
  }
  if (properties.affiliateMarker !== null && properties.affiliateMarker !== undefined) {
    sysAffiliateMarker = properties.affiliateMarker;
  }
  if (properties.awc !== null && properties.awc !== undefined) {
    sysAwc = properties.awc;
  }
  if (properties.country !== null && properties.country !== undefined) {
    sysCountry = properties.country;
  }
  if (properties.language !== null && properties.language !== undefined) {
    sysLanguage = properties.language;
  }
  if (properties.locationId !== null && properties.locationId !== undefined) {
    sysLocationId = properties.locationId;
  }
  if (properties.userId !== null && properties.userId !== undefined) {
    sysUserId = properties.userId;
  }
  if (properties.loggedIn !== null && properties.loggedIn !== undefined) {
    sysLoggedIn = properties.loggedIn;
  }
  if (properties.pageType !== null && properties.pageType !== undefined) {
    sysPageType = properties.pageType;
  }
  if (properties.gaClientId !== null && properties.gaClientId !== undefined) {
    sysGaClientId = properties.gaClientId;
  }
  if (properties.gaSessionId !== null && properties.gaSessionId !== undefined) {
    sysGaSessionId = properties.gaSessionId;
  }
  if (properties.gaSessionNumber !== null && properties.gaSessionNumber !== undefined) {
    sysGaSessionNumber = properties.gaSessionNumber;
  }
  if (properties.fbFbp !== null && properties.fbFbp !== undefined) {
    sysFbFbp = properties.fbFbp;
  }
  if (properties.fbFbc !== null && properties.fbFbc !== undefined) {
    sysFbFbc = properties.fbFbc;
  }
  if (properties.gaAwClid !== null && properties.gaAwClid !== undefined) {
    sysGaAwClid = properties.gaAwClid;
  }
  if (properties.ttclid !== null && properties.ttclid !== undefined) {
    sysTtclid = properties.ttclid;
  }
  if (properties.msclkid !== null && properties.msclkid !== undefined) {
    sysMsclkid = properties.msclkid;
  }
  if (properties.twclid !== null && properties.twclid !== undefined) {
    sysTwclid = properties.twclid;
  }
  if (properties.rdtCid !== null && properties.rdtCid !== undefined) {
    sysRdtCid = properties.rdtCid;
  }
  if (properties.epik !== null && properties.epik !== undefined) {
    sysEpik = properties.epik;
  }
}

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string;
    awc: string;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string;
    fbFbc: string;
    gaAwClid: string;
    ttclid: string;
    msclkid: string;
    twclid: string;
    rdtCid: string;
    epik: string},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    if (__AVO_ENV__ === AvoEnv.Staging) {
    }
    
    Segment = SegmentDestination;
    if (__AVO_ENV__ === 'prod') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, "4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG");
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertPreferences(preferences: Preferences[],
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList("UVEfw2bL_8DSG3paamvQG", "preferences", preferences));
  if (preferences !== null && preferences !== undefined && preferences.forEach) {
    preferences.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("UVEfw2bL_8DSG3paamvQG", "item at index " + index + " in preferences", value));
    });
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface BookingToolStoreSelectedProperties {
  storeId: string;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_store_selected: When selecting store from stores list screen
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/7QSq7At3YT/trigger/yCM4gyEGx
 * 
 * @param properties the properties associated with this event
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/7QSq7At3YT}
 */
export function bookingToolStoreSelected(properties: BookingToolStoreSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7QSq7At3YT", "4b6b367e7e699972bf5fc68bd725783513b89001abb34f4b61a5213e0d8efae9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_store_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7QSq7At3YT", "booking_tool_store_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_store_selected", eventProperties, "7QSq7At3YT", "4b6b367e7e699972bf5fc68bd725783513b89001abb34f4b61a5213e0d8efae9");
    }
    // destination Segment
    Segment.logEvent("booking_tool_store_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolEmployeeSelectedProperties {
  storeId: string;
  employeeId: string;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_employee_selected: When selecting style advisor from the booking tool on the style advisor list screen
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Kl6NaklZt5/trigger/HDPFYcjkK
 * 
 * @param properties the properties associated with this event
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Kl6NaklZt5}
 */
export function bookingToolEmployeeSelected(properties: BookingToolEmployeeSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Kl6NaklZt5", "2d9d66aeb7d0250b52eeff2b83d73ed978ad855d172c78c50c2c27366294d090", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_employee_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Kl6NaklZt5", "booking_tool_employee_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_employee_selected", eventProperties, "Kl6NaklZt5", "2d9d66aeb7d0250b52eeff2b83d73ed978ad855d172c78c50c2c27366294d090");
    }
    // destination Segment
    Segment.logEvent("booking_tool_employee_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolTimeslotSelectedProperties {
  storeId: string;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_timeslot_selected: When selecting timeslot for selected style advisor on the booking tool
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/LqD0R-Zvlb/trigger/vrs6v-kB1
 * 
 * @param properties the properties associated with this event
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/LqD0R-Zvlb}
 */
export function bookingToolTimeslotSelected(properties: BookingToolTimeslotSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "LqD0R-Zvlb", "f7c75b1e34a4c10260bbfb224006360036b05cf9f4f8ad37b3e93390c1f99c59", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_timeslot_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("LqD0R-Zvlb", "booking_tool_timeslot_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_timeslot_selected", eventProperties, "LqD0R-Zvlb", "f7c75b1e34a4c10260bbfb224006360036b05cf9f4f8ad37b3e93390c1f99c59");
    }
    // destination Segment
    Segment.logEvent("booking_tool_timeslot_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolAllStyleAdvisorsProperties {
  employeeId: string;
  storeId: string;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_all_style_advisors: When clicking on "see al style advisors" in the time slot screen on the booking tool
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/5-S5s0W6O/trigger/yIBbTVD7V
 * 
 * @param properties the properties associated with this event
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/5-S5s0W6O}
 */
export function bookingToolAllStyleAdvisors(properties: BookingToolAllStyleAdvisorsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "5-S5s0W6O", "df41850307d2316caa1a908684cd157690debf263522b7ddc3e4d8fa20fe4ba6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_all_style_advisors", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("5-S5s0W6O", "booking_tool_all_style_advisors", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_all_style_advisors", eventProperties, "5-S5s0W6O", "df41850307d2316caa1a908684cd157690debf263522b7ddc3e4d8fa20fe4ba6");
    }
    // destination Segment
    Segment.logEvent("booking_tool_all_style_advisors", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolConfirmAppointmentProperties {
  storeId: string;
  employeeId: string;
  eHash: string;
  bookingId: string;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_confirm_appointment: When confirming appointment in the last step of the booking tool
 * 
 * When to trigger this event:
 * 1. After the booking API returns success, once per booking.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lTPYcD9Tet/trigger/evo4YEaKQ
 * 
 * @param properties the properties associated with this event
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.eHash: hashed email encrypted in SHA256
 * @param properties.bookingId: Unique identifier of the booking/appointment returned by the booking API.
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lTPYcD9Tet}
 */
export function bookingToolConfirmAppointment(properties: BookingToolConfirmAppointmentProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "2NJB6Jm5kp", name: "e_hash", value: properties.eHash});
  eventPropertiesArray.push({id: "OG-oJBxGMNGNSAFc3S7Z8", name: "booking_id", value: properties.bookingId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lTPYcD9Tet", "e32334bcf60c2ff92e3147cfc4c1b7fc9e0a10b40c7495664917b994228c9fc0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_confirm_appointment", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lTPYcD9Tet", "booking_tool_confirm_appointment", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_confirm_appointment", eventProperties, "lTPYcD9Tet", "e32334bcf60c2ff92e3147cfc4c1b7fc9e0a10b40c7495664917b994228c9fc0");
    }
    // destination Segment
    Segment.logEvent("booking_tool_confirm_appointment", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolNoPreferenceSelectedProperties {
  storeId: string;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_no_preference_selected: When clicking on No Preference in the Style Advisor list screen
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/scaBRGfj8p/trigger/H3jZw71ia
 * 
 * @param properties the properties associated with this event
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/scaBRGfj8p}
 */
export function bookingToolNoPreferenceSelected(properties: BookingToolNoPreferenceSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "scaBRGfj8p", "82cafd3f118513bac2fdea55f7d07857cee1ccd6f8971d1304b065bcbfa836cd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_no_preference_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("scaBRGfj8p", "booking_tool_no_preference_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_no_preference_selected", eventProperties, "scaBRGfj8p", "82cafd3f118513bac2fdea55f7d07857cee1ccd6f8971d1304b065bcbfa836cd");
    }
    // destination Segment
    Segment.logEvent("booking_tool_no_preference_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolCountrySelectedProperties {
  flowId: string;
  locationCode: string;
  selectedCountry: SelectedCountryValueType;
}
/**
 * booking_tool_country_selected: This event represents when a user selects a country in the country selector for the appointment
 * 
 * When to trigger this event:
 * 1. When the user selects a country in the country selector
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/5rW8zooTINn532nFm4hzs/trigger/XTEjqlRUZQeUj9LynYMvY
 * 
 * @param properties the properties associated with this event
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.selectedCountry: Country the user picked in the booking tool's country dropdown, ISO 3166-1 alpha-2 in lowercase (e.g. be, de). Unlike `country`, which is the site/locale country, this is the user's choice.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/5rW8zooTINn532nFm4hzs}
 */
export function bookingToolCountrySelected(properties: BookingToolCountrySelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "iHh4cQhXrMP53oZm9lknY", name: "selected_country", value: properties.selectedCountry});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "5rW8zooTINn532nFm4hzs", "92a2a6cb116b7b1c51eac9a2e1207644ffcd4e67fac91f1c8a24a3098e56c89a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_country_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("5rW8zooTINn532nFm4hzs", "booking_tool_country_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_country_selected", eventProperties, "5rW8zooTINn532nFm4hzs", "92a2a6cb116b7b1c51eac9a2e1207644ffcd4e67fac91f1c8a24a3098e56c89a");
    }
    // destination Segment
    Segment.logEvent("booking_tool_country_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolDateSelectedProperties {
  storeId: string;
  flowId: string;
  selectedDate: string;
  availableSlots: number;
  locationCode: string;
}
/**
 * booking_tool_date_selected: When the user selects a date on the timeslots screen. Sends the date and how many slots that date has, so repeated date changes show users searching for capacity.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/aCXD-tGb1X2VYmmO2Fdm_/trigger/t1XqdGpPEFMHfB6WpVNgL
 * 
 * @param properties the properties associated with this event
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.selectedDate: Date the user selected in the booking tool, ISO format YYYY-MM-DD, in the store's local calendar.
 * @param properties.availableSlots: Number of bookable timeslots on the selected date for the selected store and advisor. 0 means no capacity that day.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/aCXD-tGb1X2VYmmO2Fdm_}
 */
export function bookingToolDateSelected(properties: BookingToolDateSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "JY1_42ybEOefuM3UxBj8Q", name: "selected_date", value: properties.selectedDate});
  eventPropertiesArray.push({id: "GF4_IWcaUIU71QXf1eIMG", name: "available_slots", value: properties.availableSlots});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aCXD-tGb1X2VYmmO2Fdm_", "bd1080c2f8815a13debe8d89048ea5478861813a0638be3d85f9e6d3fc7536ff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_date_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aCXD-tGb1X2VYmmO2Fdm_", "booking_tool_date_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_date_selected", eventProperties, "aCXD-tGb1X2VYmmO2Fdm_", "bd1080c2f8815a13debe8d89048ea5478861813a0638be3d85f9e6d3fc7536ff");
    }
    // destination Segment
    Segment.logEvent("booking_tool_date_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolContinueWithAppointmentSelectedProperties {
  storeId: string;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_continue_with_appointment_selected: When selecting timeslot for selected style advisor on the booking tool
 * 
 * When to trigger this event:
 * 1. When the user clicks in the "Continue" button after selecting a date and time slot
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/NVlq1HwE5TBpmLdHJekBt/trigger/JRD0bPP1unOe_JzDbkdDf
 * 
 * @param properties the properties associated with this event
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/NVlq1HwE5TBpmLdHJekBt}
 */
export function bookingToolContinueWithAppointmentSelected(properties: BookingToolContinueWithAppointmentSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NVlq1HwE5TBpmLdHJekBt", "2135004104c816caf79e56ed98772b06d4f001cc872434e46a1f87e7096a7641", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_continue_with_appointment_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NVlq1HwE5TBpmLdHJekBt", "booking_tool_continue_with_appointment_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_continue_with_appointment_selected", eventProperties, "NVlq1HwE5TBpmLdHJekBt", "2135004104c816caf79e56ed98772b06d4f001cc872434e46a1f87e7096a7641");
    }
    // destination Segment
    Segment.logEvent("booking_tool_continue_with_appointment_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolPanelClosedProperties {
  step: number;
  name: string | null | undefined;
  serviceId: string | null | undefined;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_panel_closed: This event represents when a custom closes the booking tool panel. It can be triggered on all booking tool steps
 * 
 * When to trigger this event:
 * 1. The user closes the booking tool. Sends the step it was on when closed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/UBDUJLWoVXcjV4Pzi9hfy/trigger/h59UpYcfcO4z0TepPD6m7
 * 
 * @param properties the properties associated with this event
 * @param properties.step: This property describes the step number from a product flow. Eg: Checkout step number, return item step number
 * Booking tool step map (booking_tool_step_viewed / booking_tool_step_completed): 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.serviceId: Service ID passed by the host (custom-made only). Empty in other hosts.
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/UBDUJLWoVXcjV4Pzi9hfy}
 */
export function bookingToolPanelClosed(properties: BookingToolPanelClosedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "7kee_Xvad", name: "step", value: properties.step});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  properties.serviceId !== undefined && properties.serviceId !== null ?
    eventPropertiesArray.push({id: "CZr2Yn346TXx3E_TsxMWv", name: "service_id", value: properties.serviceId}) :
    eventPropertiesArray.push({id: "CZr2Yn346TXx3E_TsxMWv", name: "service_id", value: null});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "UBDUJLWoVXcjV4Pzi9hfy", "1e55826541ca43ba93327ad4856b5490e27f00ed0e44ded015f32f6cd75a9bbd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_panel_closed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("UBDUJLWoVXcjV4Pzi9hfy", "booking_tool_panel_closed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_panel_closed", eventProperties, "UBDUJLWoVXcjV4Pzi9hfy", "1e55826541ca43ba93327ad4856b5490e27f00ed0e44ded015f32f6cd75a9bbd");
    }
    // destination Segment
    Segment.logEvent("booking_tool_panel_closed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolStepViewedProperties {
  eventLabel: string | null | undefined;
  eventLocation: string;
  step: number;
  name: string | null | undefined;
  storeId: string | null | undefined;
  employeeId: string | null | undefined;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_step_viewed: This event represents when the booking tool step is viewed by the user.
 * 
 * When to trigger this event:
 * 1. When the user reaches the "Select a store" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/uQ_z79pDy-vI9jel0U_U6/trigger/y8Rfg3mhhcXCFbLlpRaGo
 * 2. When the user reaches the "Find your Style Advisor" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/uQ_z79pDy-vI9jel0U_U6/trigger/wE-ehDog1jOF_FvT59a5k
 * 3. When the user reaches the "Choose your date and time" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/uQ_z79pDy-vI9jel0U_U6/trigger/sEaJqFQMVSY0Tl86ua6Au
 * 4. When the user reaches the "Share some details about you" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/uQ_z79pDy-vI9jel0U_U6/trigger/lKAKwMFu423twumykKPsz
 * 5. When the users reaches the "help us prepare your visit" screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/uQ_z79pDy-vI9jel0U_U6/trigger/werYQeCMV8zckZaFJKh6S
 * 6. When the user reaches the confirmation step (step 5).
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/uQ_z79pDy-vI9jel0U_U6/trigger/BHwmavG5wUj8yftmXAvKi
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.step: This property describes the step number from a product flow. Eg: Checkout step number, return item step number
 * Booking tool step map (booking_tool_step_viewed / booking_tool_step_completed): 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/uQ_z79pDy-vI9jel0U_U6}
 */
export function bookingToolStepViewed(properties: BookingToolStepViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "7kee_Xvad", name: "step", value: properties.step});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  properties.storeId !== undefined && properties.storeId !== null ?
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId}) :
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: null});
  properties.employeeId !== undefined && properties.employeeId !== null ?
    eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId}) :
    eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: null});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "uQ_z79pDy-vI9jel0U_U6", "49be859e2ca174de9cdcb081aa28c3a6df7909289f7e016f833319f674ed5ec4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_step_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("uQ_z79pDy-vI9jel0U_U6", "booking_tool_step_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_step_viewed", eventProperties, "uQ_z79pDy-vI9jel0U_U6", "49be859e2ca174de9cdcb081aa28c3a6df7909289f7e016f833319f674ed5ec4");
    }
    // destination Segment
    Segment.logEvent("booking_tool_step_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolStepCompletedProperties {
  eventLabel: string | null | undefined;
  eventLocation: string;
  step: number;
  name: string | null | undefined;
  storeId: string | null | undefined;
  employeeId: string | null | undefined;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_step_completed: This event represents when the booking tool step is completed by the user. 
 * 
 * When to trigger this event:
 * 1. When the user reaches the "Select a store" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j/trigger/z3xfEuMSODJ_ojFW0L7Sh
 * 2. When the user reaches the "Find your Style Advisor" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j/trigger/9LFj2t259HMZXhip2fkWr
 * 3. When the user reaches the "Choose your date and time" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j/trigger/iPLnIP7d0ipwdm4jCydMg
 * 4. When the user reaches the "Share some details about you" step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j/trigger/74V73jXjPTfIIEKlTbjM5
 * 5. When the user completes or skips the "help us prepare you visit screen"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j/trigger/VZSSj7dvwdi_8LXFS9qU4
 * 6. When the user completes the confirmation step (step 5), i.e. the booking is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j/trigger/QkcRfzjhX0debgrEF1MmR
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.step: This property describes the step number from a product flow. Eg: Checkout step number, return item step number
 * Booking tool step map (booking_tool_step_viewed / booking_tool_step_completed): 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j}
 */
export function bookingToolStepCompleted(properties: BookingToolStepCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "7kee_Xvad", name: "step", value: properties.step});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  properties.storeId !== undefined && properties.storeId !== null ?
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId}) :
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: null});
  properties.employeeId !== undefined && properties.employeeId !== null ?
    eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId}) :
    eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: null});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Keupll7bJ39urukYR0K1j", "16b108492de4e3e2603dbe74034df2b20cdb5348b763a23dcf159888f5b89657", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_step_completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Keupll7bJ39urukYR0K1j", "booking_tool_step_completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_step_completed", eventProperties, "Keupll7bJ39urukYR0K1j", "16b108492de4e3e2603dbe74034df2b20cdb5348b763a23dcf159888f5b89657");
    }
    // destination Segment
    Segment.logEvent("booking_tool_step_completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolStepCompletedCustomerHubProperties {
  eventLabel: string | null | undefined;
  eventLocation: string;
  step: number;
  name: string | null | undefined;
  storeId: string | null | undefined;
  employeeId: string | null | undefined;
  flowId: string;
  locationCode: string;
}
/**
 * booking_tool_step_completed: This event represents when the booking tool step is completed by the user., event variant
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.step: This property describes the step number from a product flow. Eg: Checkout step number, return item step number
 * Booking tool step map (booking_tool_step_viewed / booking_tool_step_completed): 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Keupll7bJ39urukYR0K1j.Ec5cDCnzcJWVuVe779Gc3}
 */
export function bookingToolStepCompletedCustomerHub(properties: BookingToolStepCompletedCustomerHubProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "7kee_Xvad", name: "step", value: properties.step});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  properties.storeId !== undefined && properties.storeId !== null ?
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId}) :
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: null});
  properties.employeeId !== undefined && properties.employeeId !== null ?
    eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId}) :
    eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: null});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Keupll7bJ39urukYR0K1j.Ec5cDCnzcJWVuVe779Gc3", "04ba1cd09ced4fced9cbd68d7d1e764d638094983f50058a4fddf1e66932e46d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_step_completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Keupll7bJ39urukYR0K1j.Ec5cDCnzcJWVuVe779Gc3", "booking_tool_step_completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_step_completed", eventProperties, "Keupll7bJ39urukYR0K1j.Ec5cDCnzcJWVuVe779Gc3", "04ba1cd09ced4fced9cbd68d7d1e764d638094983f50058a4fddf1e66932e46d");
    }
    // destination Segment
    Segment.logEvent("booking_tool_step_completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ExperimentViewedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  experimentId: string;
  variationId: string;
  locationCode: string;
}
/**
 * Experiment Viewed: This event indicates which AB testing experience is currently running and which variant the customer is experiencing it.
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.experimentId: This property indicates which experiment is currently active.
 * @param properties.variationId: This property indicates which variation of the experiment is currently active.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/412a4bec-8cc6-446b-a490-0e48bddfb269}
 */
export function experimentViewed(properties: ExperimentViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "ZhUIj6XE6s7Jbtktw4qi5", name: "experiment_id", value: properties.experimentId});
  eventPropertiesArray.push({id: "b4rOVE-4v2K_eHPaqIgzS", name: "variation_id", value: properties.variationId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "412a4bec-8cc6-446b-a490-0e48bddfb269", "eb2ebb9d95bee284014716a711f3bd114b17d2aa21f307d4081757c14eca230a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Experiment Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("412a4bec-8cc6-446b-a490-0e48bddfb269", "Experiment Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Experiment Viewed", eventProperties, "412a4bec-8cc6-446b-a490-0e48bddfb269", "eb2ebb9d95bee284014716a711f3bd114b17d2aa21f307d4081757c14eca230a");
    }
    // destination Segment
    Segment.logEvent("Experiment Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PreferencesSkippedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  flowId: string;
  locationCode: string;
}
/**
 * preferences_skipped: This event represents when the user skips preferences for their booking
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Hq1T7bIGFd7FArk-qdqqK}
 */
export function preferencesSkipped(properties: PreferencesSkippedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Hq1T7bIGFd7FArk-qdqqK", "48ae69ae617818121d7c025c8f0ba12ddb031077089023a546cb7f674705788c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("preferences_skipped", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Hq1T7bIGFd7FArk-qdqqK", "preferences_skipped", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("preferences_skipped", eventProperties, "Hq1T7bIGFd7FArk-qdqqK", "48ae69ae617818121d7c025c8f0ba12ddb031077089023a546cb7f674705788c");
    }
    // destination Segment
    Segment.logEvent("preferences_skipped", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PreferencesSubmittedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  preferences: Preferences[];
  serviceId: string | null | undefined;
  flowId: string;
  locationCode: string;
}
/**
 * preferences_submitted: This event represents when the user submits preferences for their booking.
 * 
 * When to trigger this event:
 * 1. When the users submits preferences for their appointment
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/25350497-f26d-4ff5-9d60-2a4eb80afd18/trigger/gPUo5wk9iE67AOJZqGUZu
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.preferences: This property describes the set of preference a customer has selected for a booking
 * @param properties.serviceId: Service ID passed by the host (custom-made only). Empty in other hosts.
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/25350497-f26d-4ff5-9d60-2a4eb80afd18}
 */
export function preferencesSubmitted(properties: PreferencesSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "UVEfw2bL_8DSG3paamvQG", name: "preferences", value: properties.preferences.map(function(value) { return {
      "occasion": value.occasion,
      "color": value.color,
      "note": value.note,
    }
  })});
  properties.serviceId !== undefined && properties.serviceId !== null ?
    eventPropertiesArray.push({id: "CZr2Yn346TXx3E_TsxMWv", name: "service_id", value: properties.serviceId}) :
    eventPropertiesArray.push({id: "CZr2Yn346TXx3E_TsxMWv", name: "service_id", value: null});
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPreferences(properties.preferences));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "25350497-f26d-4ff5-9d60-2a4eb80afd18", "300bb50411798d67e9b009e07c134e86c0cee6ca018d0ca9b6bee7f597f730c8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("preferences_submitted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("25350497-f26d-4ff5-9d60-2a4eb80afd18", "preferences_submitted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'preferences_submitted': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("preferences_submitted", eventProperties, "25350497-f26d-4ff5-9d60-2a4eb80afd18", "300bb50411798d67e9b009e07c134e86c0cee6ca018d0ca9b6bee7f597f730c8");
    }
    // destination Segment
    Segment.logEvent("preferences_submitted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolOpenedProperties {
  flowId: string;
  flowType: FlowTypeValueType;
  storeId: string | null | undefined;
  locationCode: string;
}
/**
 * booking_tool_opened: Fired once when the booking tool mounts. Starts a new booking flow.
 * 
 * When to trigger this event:
 * 1. Once, when the booking tool mounts.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/9_MDSoC2eu1e9HDg_2TdQ/trigger/yOxwMtJzgTtjeTQgD2hN5
 * 
 * @param properties the properties associated with this event
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.flowType: Type of booking flow the user is in: new (booking a new appointment), reschedule, or cancel.
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/9_MDSoC2eu1e9HDg_2TdQ}
 */
export function bookingToolOpened(properties: BookingToolOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "_CITrq4pg-W8ifn0xrejz", name: "flow_type", value: properties.flowType});
  properties.storeId !== undefined && properties.storeId !== null ?
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId}) :
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: null});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "booking_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9_MDSoC2eu1e9HDg_2TdQ", "c4b68445c925d8a56f79708b4a6ecd97054e8d723b4ca43cbbbdb56ca0c31e7e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9_MDSoC2eu1e9HDg_2TdQ", "booking_tool_opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_opened", eventProperties, "9_MDSoC2eu1e9HDg_2TdQ", "c4b68445c925d8a56f79708b4a6ecd97054e8d723b4ca43cbbbdb56ca0c31e7e");
    }
    // destination Segment
    Segment.logEvent("booking_tool_opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolErrorProperties {
  flowId: string;
  step: number;
  name: string | null | undefined;
  errorType: ErrorTypeValueType;
  storeId: string | null | undefined;
  locationCode: string;
}
/**
 * booking_tool_error: Fired when the booking tool hits an error (booking failed, captcha failed, or a data screen failed to load). Folds in what used to be booking_tool_captcha_failed via error_type.
 * 
 * @param properties the properties associated with this event
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.step: This property describes the step number from a product flow. Eg: Checkout step number, return item step number
 * Booking tool step map (booking_tool_step_viewed / booking_tool_step_completed): 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.errorType: Type of error encountered in the booking tool.
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/rkfdTubrLmTEpHCKaDagI}
 */
export function bookingToolError(properties: BookingToolErrorProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "7kee_Xvad", name: "step", value: properties.step});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "EKw0repix1JaaSGBZfR__", name: "error_type", value: properties.errorType});
  properties.storeId !== undefined && properties.storeId !== null ?
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId}) :
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: null});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rkfdTubrLmTEpHCKaDagI", "1de1fc0ea394d5a0a954503c652b8bec4c00aca8ee0d81f9480507716fed948b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_error", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rkfdTubrLmTEpHCKaDagI", "booking_tool_error", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_error", eventProperties, "rkfdTubrLmTEpHCKaDagI", "1de1fc0ea394d5a0a954503c652b8bec4c00aca8ee0d81f9480507716fed948b");
    }
    // destination Segment
    Segment.logEvent("booking_tool_error", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookingToolCancelConfirmedProperties {
  flowId: string;
  bookingId: string;
  storeId: string;
  locationCode: string;
}
/**
 * booking_tool_cancel_confirmed: Fired after the cancel API returns success, once per booking cancellation.
 * 
 * When to trigger this event:
 * 1. After the cancel API returns success.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Qt0YLbPzeadLkjOLSWi65/trigger/aehDZ0NATLz4Dcy6XslGk
 * 
 * @param properties the properties associated with this event
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.bookingId: Unique identifier of the booking/appointment returned by the booking API.
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Qt0YLbPzeadLkjOLSWi65}
 */
export function bookingToolCancelConfirmed(properties: BookingToolCancelConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId});
  eventPropertiesArray.push({id: "OG-oJBxGMNGNSAFc3S7Z8", name: "booking_id", value: properties.bookingId});
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Qt0YLbPzeadLkjOLSWi65", "9ec4d47e2c51d369c1cbfa1d5c51fddf99678d7f43f77771021e3daf7040c728", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("booking_tool_cancel_confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Qt0YLbPzeadLkjOLSWi65", "booking_tool_cancel_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("booking_tool_cancel_confirmed", eventProperties, "Qt0YLbPzeadLkjOLSWi65", "9ec4d47e2c51d369c1cbfa1d5c51fddf99678d7f43f77771021e3daf7040c728");
    }
    // destination Segment
    Segment.logEvent("booking_tool_cancel_confirmed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  ErrorType,
  LoggedIn,
  EventCategory,
  Language,
  PageType,
  FlowType,
  SelectedCountry,
  Country,
  ApplicationId,
  bookingToolStoreSelected,
  bookingToolEmployeeSelected,
  bookingToolTimeslotSelected,
  bookingToolAllStyleAdvisors,
  bookingToolConfirmAppointment,
  bookingToolNoPreferenceSelected,
  bookingToolCountrySelected,
  bookingToolDateSelected,
  bookingToolContinueWithAppointmentSelected,
  bookingToolPanelClosed,
  bookingToolStepViewed,
  bookingToolStepCompleted,
  bookingToolStepCompletedCustomerHub,
  experimentViewed,
  preferencesSkipped,
  preferencesSubmitted,
  bookingToolOpened,
  bookingToolError,
  bookingToolCancelConfirmed,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["bookingToolStoreSelected","bookingToolEmployeeSelected","bookingToolTimeslotSelected","bookingToolAllStyleAdvisors","bookingToolConfirmAppointment","bookingToolNoPreferenceSelected","bookingToolCountrySelected","bookingToolDateSelected","bookingToolContinueWithAppointmentSelected","bookingToolPanelClosed","bookingToolStepViewed","bookingToolStepCompleted","bookingToolStepCompletedCustomerHub","experimentViewed","preferencesSkipped","preferencesSubmitted","bookingToolOpened","bookingToolError","bookingToolCancelConfirmed"]
